var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8282 3.305C13.8282 3.305 14.3807 3.84667 13.8282 3.305C13.0877 2.45959 12.6796 1.37389 12.6799 0.25H9.3324V13.6833C9.30658 14.4103 8.99967 15.0988 8.47631 15.604C7.95294 16.1092 7.25396 16.3916 6.52656 16.3917C4.98823 16.3917 3.7099 15.135 3.7099 13.575C3.7099 11.7117 5.50823 10.3142 7.36073 10.8883V7.465C3.62323 6.96667 0.351562 9.87 0.351562 13.575C0.351562 17.1825 3.34156 19.75 6.51573 19.75C9.9174 19.75 12.6799 16.9875 12.6799 13.575V6.76083C14.0373 7.73567 15.667 8.2587 17.3382 8.25583V4.90833C17.3382 4.90833 15.3016 5.00583 13.8282 3.305Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialJ);
export default __webpack_public_path__ + "static/media/Social-J.1c5786f770ea33070208356b971ca52f.svg";
export { ForwardRef as ReactComponent };